import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Table, TableBody, TableCell, TableHead, TableRow, Link, CircularProgress } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import Error from '../common/Error';

export default function MetricGrowthPanel(props) {
  const DATAPOINT_QUERY = gql`
    query getFastestGrowingMetrics($year: String) {
      growingFastestByYear(year: $year, first: 5) {
        value
        timeframe {
          name
        }
        metric {
          id
          name
        }
      }
    }
  `;

  const result = useQuery(DATAPOINT_QUERY, {
    variables: {
      year: props.year
    }
  });

  return result.loading ? (
    <CircularProgress />
  ) : result.error ? (
    <Error />
  ) : (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Metric</TableCell>
          <TableCell>Growth</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {result.data.growingFastestByYear.map(row => (
          <TableRow key={row.metric.name}>
            <TableCell component='th' scope='row'>
              <Link to={`/metric/${row.metric.id}`} component={RouterLink}>
                {row.metric.name}
              </Link>
            </TableCell>
            <TableCell>{`${row.value.toFixed(2)} %`}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
